const MilestonesPanel = () => {
  return (
    <div className="Milestones">
      <div className="flex col large-gap">
        <div className="flex row space center">
          <p className="xlarge padding">Milestones</p>
        </div>

        <div className="flex col medium-gap">
          <div className="card">
            <p className="regular o60">Milestones coming soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilestonesPanel;
